export { Animation, type AnimationVariant, Locale } from './Animation';
